import script from "./Wysiwyg.vue?vue&type=script&setup=true&lang=js"
export * from "./Wysiwyg.vue?vue&type=script&setup=true&lang=js"

import "./Wysiwyg.vue?vue&type=style&index=0&id=451b54ba&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-451b54ba"]])

export default __exports__